import { create } from 'zustand';
import api from '../utils/api';

// Only non-sensitive user profile is persisted locally — no tokens in localStorage
const storedUser = () => {
  try { return JSON.parse(localStorage.getItem('vritiethnic_user') || 'null'); } catch { return null; }
};

const useAuthStore = create((set, get) => ({
  user: storedUser(),
  loading: false,

  // Called on app mount to rehydrate session via cookie
  init: async () => {
    try {
      const data = await api.get('/auth/me');
      localStorage.setItem('vritiethnic_user', JSON.stringify(data.user));
      set({ user: data.user });
    } catch {
      localStorage.removeItem('vritiethnic_user');
      set({ user: null });
    }
  },

  sendOTP: async (phone) => {
    set({ loading: true });
    try {
      await api.post('/auth/send-otp', { phone });
      set({ loading: false });
      return { success: true };
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  verifyOTP: async (phone, otp) => {
    set({ loading: true });
    try {
      const data = await api.post('/auth/verify-otp', { phone, otp });
      // Backend sets httpOnly access + refresh cookies — we only persist the user profile
      localStorage.setItem('vritiethnic_user', JSON.stringify(data.user));
      set({ user: data.user, loading: false });
      return data;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  register: async (name, phone, email, password) => {
    set({ loading: true });
    try {
      const data = await api.post('/auth/register', { name, phone, email, password });
      localStorage.setItem('vritiethnic_user', JSON.stringify(data.user));
      set({ user: data.user, loading: false });
      return data;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  emailLogin: async (email, password) => {
    set({ loading: true });
    try {
      const data = await api.post('/auth/login', { email, password });
      localStorage.setItem('vritiethnic_user', JSON.stringify(data.user));
      set({ user: data.user, loading: false });
      return data;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  adminLogin: async (email, password) => {
    set({ loading: true });
    try {
      const data = await api.post('/auth/admin-login', { email, password });
      localStorage.setItem('vritiethnic_user', JSON.stringify(data.user));
      set({ user: data.user, loading: false });
      return data;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  logout: async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('vritiethnic_user');
    set({ user: null });
  },

  updateProfile: async (data) => {
    const res = await api.put('/auth/profile', data);
    localStorage.setItem('vritiethnic_user', JSON.stringify(res.user));
    set({ user: res.user });
    return res;
  },
}));

export default useAuthStore;
